import { IconConfig, iconColors } from "./icon-config";
import { SVGIcon } from "./svg-icon";

interface IconProps extends IconConfig {
    size?: number;
}
export function Icon({ icon, type, centerContent, size = 24, color = iconColors.default }: IconProps) {
    const IconComponent = icon;
    if (type === "SVG") {
        return <SVGIcon icon={IconComponent} size={size} iconColor={color} />;
    }
    if (type === "Text") {
        return <IconComponent centerContent={centerContent} size={size} color={color} />;
    }
    return <></>;
}
